import {
  CheckboxMarkCompleteCheckedIcon,
  CheckboxMarkCompleteUncheckedIcon,
} from '@sketchnote/icons';
import classNames from 'classnames';
import React, { memo, useEffect, useRef } from 'react';

import styles from './checkbox.module.css';

interface CheckboxProps {
  onChange?: (arg: any) => void;
  checked?: boolean;
  isDisabled?: boolean;
  isFocussed?: boolean;
  wrapperClass?: string;
  color?: string;
  crossed?: boolean;
  checkOnPressingEnter?: boolean;
}

export const CheckboxMarkComplete = memo(
  ({
    onChange,
    checked,
    isDisabled,
    isFocussed,
    wrapperClass,
    color,
    checkOnPressingEnter,
  }: CheckboxProps) => {
    const isChecked = checked;
    const checkboxInputRef = useRef<HTMLInputElement>(null);

    const handleChange = (e) => {
      e.stopPropagation();
      if (onChange) {
        onChange(!isChecked);
      }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
      if (onChange && checkOnPressingEnter && e.key === 'Enter') onChange(!isChecked);
    };

    const wrapperClasses = classNames({
      'flex items-center': true,
      [wrapperClass || '']: !!wrapperClass,
    });

    useEffect(() => {
      if (isFocussed) {
        checkboxInputRef.current?.focus();
      }
    }, [isFocussed]);

    return (
      <div aria-disabled={isDisabled} className={wrapperClasses} aria-label="checkbox component">
        <input
          type="checkbox"
          className={classNames(styles['sn-checkbox-input'], 'hidden')}
          aria-label="checkbox component"
          checked={isChecked}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleChange(e);
          }}
          disabled={isDisabled}
          tabIndex={0}
          ref={checkboxInputRef}
          onKeyPress={handleKeyPress}
        />
        <label
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (isDisabled) return;
            handleChange(e);
          }}
          style={{
            color: isChecked ? color : undefined,
          }}
          className={classNames(
            'text-gray-500 flex items-center hover:opacity-75 transition-all duration-200',
            !isDisabled && 'cursor-pointer'
          )}
        >
          {checked ? (
            <CheckboxMarkCompleteCheckedIcon size={20} />
          ) : (
            <CheckboxMarkCompleteUncheckedIcon size={20} />
          )}
        </label>
      </div>
    );
  }
);
